import './_styles.scss';
import React from 'react';
import numeral from 'numeral';

const toggle = () => document.getElementById('checkout-summary').classList.toggle('open');

export default ({ step = 1, total=0 }) => {
  return (
    <div className='Checkout-Progress'>

      <div className="Checkout-Heading">Cart Checkout</div>

      <div className="order-summary-mobile" onClick={toggle}>
        <div className="caption">Show Full Summary</div>
        <div className="value">{`${numeral(total).format('0,0.00')} KES`}</div>
      </div>

      <div className="Checkout-Step-Counter ">

        <span className={((step===1) && 'Active') || ''}>Customer Information</span>

        <span className='spacer' content='>'/>

        <span className={((step===2) && 'Active') || ''}>Shipping Method</span>

        <span className='spacer' content='>'/>

        <span className={((step===3) && 'Active') || ''}>Payment Method</span>

      </div>

    </div>
  )
}
